var $b5d80d3b86cad359$exports = {};
$b5d80d3b86cad359$exports = {
    "Clear search": `Vymazat hled\xe1n\xed`
};


export {$b5d80d3b86cad359$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
